/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateFacilityPhysician201ResponseData
 */
export interface CreateFacilityPhysician201ResponseData {
    /**
     * 
     * @type {string}
     * @memberof CreateFacilityPhysician201ResponseData
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFacilityPhysician201ResponseData
     */
    facility_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFacilityPhysician201ResponseData
     */
    physician_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFacilityPhysician201ResponseData
     */
    physician_npi?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFacilityPhysician201ResponseData
     */
    is_default?: boolean;
}

/**
 * Check if a given object implements the CreateFacilityPhysician201ResponseData interface.
 */
export function instanceOfCreateFacilityPhysician201ResponseData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function CreateFacilityPhysician201ResponseDataFromJSON(json: any): CreateFacilityPhysician201ResponseData {
    return CreateFacilityPhysician201ResponseDataFromJSONTyped(json, false);
}

export function CreateFacilityPhysician201ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityPhysician201ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
        'physician_name': !exists(json, 'physician_name') ? undefined : json['physician_name'],
        'physician_npi': !exists(json, 'physician_npi') ? undefined : json['physician_npi'],
        'is_default': !exists(json, 'is_default') ? undefined : json['is_default'],
    };
}

export function CreateFacilityPhysician201ResponseDataToJSON(value?: CreateFacilityPhysician201ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'facility_id': value.facility_id,
        'physician_name': value.physician_name,
        'physician_npi': value.physician_npi,
        'is_default': value.is_default,
    };
}

